<template>
  <label class="d-flex justify-content-center h1">
    Settings Vue
  </label>
</template>

<script>
export default {}
</script>
